module.exports = __webpack_public_path__ + "img/27.cbb8937a.jpg";